var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCardSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.03 1.75c-1.27 0-2.03.76-2.03 2.03v2.94c0 1.27.76 2.03 2.03 2.03h2.94c1.27 0 2.03-.76 2.03-2.03V3.78c0-1.27-.76-2.03-2.03-2.03h-2.94zm2.72 3.49a.62.62 0 0 1-.44-.18l-.18-.18v2.24c0 .35-.28.63-.63.63s-.63-.28-.63-.63V4.88l-.18.18c-.24.24-.64.24-.88 0a.628.628 0 0 1 0-.88l1.25-1.25c.05-.05.12-.09.19-.12.02-.01.04-.01.06-.02.05-.02.1-.03.16-.03h.06c.07 0 .13.01.2.04h.02c.07.03.13.07.18.12.01.01.01.01.02.01l1.25 1.25c.24.24.24.64-.01.88a.62.62 0 0 1-.44.18zM2 16.46c0 2.29 1.85 4.14 4.14 4.14h11.71c2.29 0 4.15-1.86 4.15-4.15v-4.99c0-.67-.54-1.21-1.21-1.21H3.21c-.67 0-1.21.54-1.21 1.21v5zm4 .79c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75H6zm4.5 0c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.538c0 .67-.54 1.21-1.21 1.21H3.21c-.68 0-1.21-.56-1.21-1.23.01-1.13.46-2.16 1.21-2.91S5 3.398 6.14 3.398h6.15c.67 0 1.21.54 1.21 1.21v2.93z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCardSend);
export default __webpack_public_path__ + "static/media/vuesax-bold-card-send.8b198c33d484df74e7f08788876274fa.svg";
export { ForwardRef as ReactComponent };